import { IconAngleDown } from '@maia/icons';
import { Typography } from '../../../atoms/typography/typography';
import { ComponentProps } from 'react';
import { Button } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

type Props = {
  title: string;
  className?: string;
} & Omit<ComponentProps<typeof Button>, 'children' | 'className'>;

export function Dropdown(props: Props) {
  const { title, className, ...rest } = props;

  return (
    <Button
      className={twMerge(
        'flex items-center gap-x-12 overflow-hidden',
        className,
      )}
      {...rest}
    >
      <IconAngleDown className="fill-info300 size-20" />
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-grayscale600"
      >
        {title}
      </Typography>
    </Button>
  );
}
